import { MEDIA_CDN } from "./constants";

export function getAssetURL(asset, size) {
    if (!asset) return asset;
    const assetNameWithoutRoot = asset.replace(/^\//, "");
    return `${MEDIA_CDN}${assetNameWithoutRoot}`;
}
